import Container from "@mui/material/Container";

import { Outlet } from "react-router-dom";

import { LoginScreenHeader } from "components";

import { Instance } from "./components/Instance";

export const AuthLayout = () => {
  return (
    <Container maxWidth="xs">
      <LoginScreenHeader title="Welcome to Luna Locate" />
      <Instance />
      <Outlet />
    </Container>
  );
};
